import { lifiLogoUrl } from '../icons/lifi.js';
export const defaultMetaMaskConfig = {
    dappMetadata: {
        name: 'LI.FI',
        url: typeof window !== 'undefined'
            ? window?.location.href
            : 'https://li.fi/',
        iconUrl: lifiLogoUrl,
    },
};
//# sourceMappingURL=metaMask.js.map